// pages/FormViewerPage/services/formViewerService/funnelFormView.ts — event ukur FormView (split dari funnelEvents.ts)
import type { FunnelEventParams } from './funnelTypes';
import { alreadyFired, hasFiredSessionKey, markFiredSessionKey } from './funnelSession';
import { ensureFbqStub, initPixels } from './funnelMeta';

// Tembak event ukur FormView (form terlihat) — 1x per sesi tab.
// BUKAN event optimasi: Meta trackCustom + nama custom di TikTok/Google tidak
// dibaca algoritma bidding kecuali dipilih eksplisit. TANPA CAPI.
// Dipakai standalone DAN embed (di embed = metrik "iframe ke-render").
export function fireFormViewEvent(
    platform: 'meta' | 'tiktok' | 'google',
    pixelIds: string[],
    params: FunnelEventParams,
    sessionKey: string,
    userData?: Record<string, string>
): boolean {
    try {
        if (!pixelIds || pixelIds.length === 0) return false;
        // Guard per cabang di bawah (meta: set-sebelum-tembak via alreadyFired;
        // tiktok/google: intip dulu agar retry tidak diblokir, tandai saat sukses).
        const w = window as any;
        if (platform === 'meta') {
            if (alreadyFired(sessionKey)) return false;
            if (!ensureFbqStub()) return false;
            initPixels(pixelIds, userData);
            w.fbq('trackCustom', 'FormView', {
                content_ids: params.content_ids || [],
                content_name: params.content_name || 'Form',
                content_type: 'product',
                currency: 'IDR',
            });
            return true;
        }
        if (platform === 'tiktok') {
            if (hasFiredSessionKey(sessionKey)) return false;
            const ttq = w.ttq;
            if (!ttq || typeof ttq.instance !== 'function') {
                setTimeout(() => fireFormViewEvent(platform, pixelIds, params, sessionKey), 2500);
                return false;
            }
            for (const id of pixelIds) {
                const t = id?.trim();
                if (!t) continue;
                try {
                    if (!ttq._i || !ttq._i[t]) ttq.load(t);
                    ttq.instance(t).track('FormView', {
                        content_type: 'product',
                        currency: 'IDR',
                        ...(params.content_ids ? { content_ids: params.content_ids } : {}),
                        ...(params.content_name ? { content_name: params.content_name } : {}),
                    });
                } catch { /* abaikan per pixel */ }
            }
            markFiredSessionKey(sessionKey);
            return true;
        }
        // google
        if (hasFiredSessionKey(sessionKey)) return false;
        const gtag = w.gtag;
        if (typeof gtag !== 'function') {
            setTimeout(() => fireFormViewEvent(platform, pixelIds, params, sessionKey), 2500);
            return false;
        }
        for (const id of pixelIds) {
            const t = id?.trim();
            if (!t) continue;
            try { gtag('config', t); } catch { /* abaikan */ }
        }
        gtag('event', 'form_view', { currency: 'IDR' });
        markFiredSessionKey(sessionKey);
        return true;
    } catch { return false; }
}
